import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomahabaleshwartempotraveller() {



  const cardData = {
"keyword": "Pune to Mahabaleshwar Tempo Traveller",

"headingDescription":
  "Aaradhya Travels provides comfortable Pune to Mahabaleshwar Tempo Traveller service for family trips, group tours, corporate outings, and weekend vacations. Our well-maintained AC Tempo Travellers with experienced drivers ensure safe and smooth travel through scenic hill routes. We offer flexible booking, affordable pricing, and convenient pickup services across Pune for hassle-free group travel.",

"topPlaces": [
  {
    "title": "Venna Lake Mahabaleshwar",
    "description":
      "Venna Lake is one of the most popular tourist attractions in Mahabaleshwar known for boating, horse riding, and beautiful hill station surroundings."
  },
  {
    "title": "Mapro Garden",
    "description":
      "Mapro Garden is famous for strawberry products, food courts, chocolate items, and family-friendly atmosphere in Mahabaleshwar."
  },
  {
    "title": "Arthur Seat Point",
    "description":
      "Arthur Seat Point offers breathtaking valley views and is one of the most visited scenic viewpoints in Mahabaleshwar."
  },
  {
    "title": "Elephant Head Point",
    "description":
      "Elephant Head Point is known for its naturally shaped rock formation and panoramic mountain landscapes."
  },
  {
    "title": "Wilson Point",
    "description":
      "Wilson Point is the highest viewpoint in Mahabaleshwar and a popular location for sunrise views and photography."
  },
  {
    "title": "Lingmala Waterfall",
    "description":
      "Lingmala Waterfall is a scenic waterfall surrounded by greenery and attracts visitors especially during monsoon season."
  },
  {
    "title": "Pratapgad Fort",
    "description":
      "Pratapgad Fort is a historic Maratha fort near Mahabaleshwar known for its historical importance and mountain views."
  },
  {
    "title": "Panchgani",
    "description":
      "Panchgani is a beautiful hill station near Mahabaleshwar famous for valleys, viewpoints, boarding schools, and pleasant weather."
  },
  {
    "title": "Table Land Panchgani",
    "description":
      "Table Land is a large volcanic plateau in Panchgani offering horse riding, sightseeing, and scenic valley views."
  },
  {
    "title": "Kate Point",
    "description":
      "Kate Point is a famous tourist spot in Mahabaleshwar known for deep valleys, mountain scenery, and cool climate."
  },
  {
    "title": "Bhilar Waterfalls",
    "description":
      "Bhilar Waterfalls is a peaceful nature attraction near Mahabaleshwar offering refreshing scenic beauty during rainy season."
  },
  {
    "title": "Mahabaleshwar Temple",
    "description":
      "Mahabaleshwar Temple is an ancient Shiva temple visited by pilgrims and tourists for spiritual and cultural significance."
  },
  {
    "title": "Elphinstone Point",
    "description":
      "Elphinstone Point provides stunning views of the Koyna Valley and surrounding mountain ranges."
  },
  {
    "title": "Bombay Point",
    "description":
      "Bombay Point is a famous sunset viewpoint in Mahabaleshwar attracting tourists for evening sightseeing."
  },
  {
    "title": "Tapola Lake",
    "description":
      "Tapola Lake is known as Mini Kashmir and offers boating, lakeside camping, and scenic nature experiences."
  },
  {
    "title": "Parsi Point",
    "description":
      "Parsi Point in Panchgani offers peaceful valley views and is a popular stop for sightseeing and photography."
  },
  {
    "title": "Rajpuri Caves",
    "description":
      "Rajpuri Caves are ancient caves near Panchgani visited for their historical and spiritual importance."
  },
  {
    "title": "Connaught Peak",
    "description":
      "Connaught Peak is a scenic viewpoint in Mahabaleshwar known for sunrise and sunset views across the hills."
  },
  {
    "title": "Velocity Entertainmentz",
    "description":
      "Velocity Entertainmentz is a popular amusement and adventure park near Panchgani with fun activities for families and groups."
  },
  {
    "title": "Strawberry Farms Mahabaleshwar",
    "description":
      "Mahabaleshwar is famous for fresh strawberry farms where tourists enjoy fruit picking and local farm products."
  }
],



   services: [
  {
    name: "Tempo Traveller from Pune to Mahabaleshwar",
    description: "Tempo Traveller from Pune to Mahabaleshwar service provides comfortable transportation for families, tourists, corporate groups, and weekend travelers planning hill station trips from Pune. Spacious vehicles ensure smooth ghat road journeys with comfortable seating and luggage space suitable for long-distance travel. Professional drivers provide safe driving and reliable transportation services throughout the Mahabaleshwar route. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Mahabaleshwar traveller reservations."
  },
  {
    name: "Pune to Mahabaleshwar Tempo Traveller Hire",
    description: "Pune to Mahabaleshwar Tempo Traveller hire service offers dependable group transportation for sightseeing tours, holiday vacations, family trips, and corporate outings. Comfortable vehicles ensure smooth highway and hill station travel suitable for all passenger groups. Professional chauffeurs provide safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow easy Mahabaleshwar traveller hire reservations."
  },
  {
    name: "Pune to Panchgani Tempo Traveller",
    description: "Pune to Panchgani Tempo Traveller service provides reliable transportation for tourists, families, students, and corporate travelers visiting the scenic hill station of Panchgani from Pune. Spacious vehicles ensure comfortable travel suitable for group tours, vacations, and educational trips. Professional drivers ensure smooth ghat road driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Panchgani traveller reservations."
  },
  {
    name: "Tempo Traveller for Rent in Pune",
    description: "Tempo Traveller for rent in Pune service offers spacious and economical transportation for local sightseeing, airport transfers, wedding travel, corporate outings, and outstation tours. Comfortable seating and smooth highway performance ensure pleasant travel experiences for all passenger groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient traveller rental reservations."
  },
  {
    name: "Tempo Traveller 17 Seater for Mahabaleshwar Trip",
    description: "Tempo Traveller 17 seater for Mahabaleshwar trip service provides spacious transportation for large families, tourist groups, corporate outings, and weekend vacation tours. Comfortable pushback seating and luggage space ensure smooth hill station travel experiences for all passengers. Professional drivers provide safe ghat road driving and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient 17 seater traveller reservations."
  },
  {
    name: "17 Seater Tempo Traveller for Mahabaleshwar Tour Package",
    description: "17 seater Tempo Traveller for Mahabaleshwar tour package service offers comfortable group transportation for sightseeing trips, family vacations, educational tours, and corporate travel. Spacious interiors ensure smooth long-distance travel suitable for large passenger groups and tourists. Professional chauffeurs ensure safe driving and punctual pickup services throughout the Mahabaleshwar journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Mahabaleshwar tour traveller reservations."
  },
  {
    name: "Pune Airport to Mahabaleshwar Tempo Traveller on Rent",
    description: "Pune Airport to Mahabaleshwar Tempo Traveller on rent service provides direct airport pickup transportation for tourists, families, and corporate groups arriving in Pune for Mahabaleshwar trips. Spacious vehicles ensure comfortable luggage handling and smooth highway travel to hill station destinations. Professional chauffeurs ensure timely airport pickup and safe driving services throughout the route. Pickup services are available directly from Pune Airport terminals with flexible scheduling options. Convenient booking options allow hassle-free airport traveller reservations."
  },
  {
    name: "Pune to Tapola Tempo Traveller on Rent",
    description: "Pune to Tapola Tempo Traveller on rent service offers reliable transportation for tourists planning nature trips, lake visits, camping tours, and group vacations to Tapola from Pune. Comfortable vehicles ensure smooth highway and village road travel suitable for family tours and adventure travel. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Tapola traveller reservations."
  },
  {
    name: "14 Seater Tempo Traveller for Maharashtra Trip",
    description: "14 seater Tempo Traveller for Maharashtra trip service provides comfortable transportation for group travel across Maharashtra tourist destinations including Mahabaleshwar, Shirdi, Lonavala, Goa, Nashik, and Konkan tours. Spacious seating and luggage space ensure smooth long-distance travel for families and tourists. Professional chauffeurs ensure safe driving and reliable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Maharashtra traveller reservations."
  },
  {
    name: "Tempo Traveller on Rent Mahabaleshwar Outings",
    description: "Tempo Traveller on rent Mahabaleshwar outings service offers dependable transportation for sightseeing tours, group vacations, educational trips, and family outings to Mahabaleshwar. Comfortable vehicles ensure smooth hill station travel suitable for tourists and weekend travelers. Professional drivers provide safe driving and reliable transportation services across all Mahabaleshwar sightseeing routes. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Mahabaleshwar outing traveller reservations."
  },
  {
    name: "Mini Bus on Rent for Mahabaleshwar Trip",
    description: "Mini bus on rent for Mahabaleshwar trip service provides spacious transportation for large groups, school tours, family vacations, corporate outings, and tourist travel. Comfortable seating and ample luggage space ensure smooth highway and hill station journeys for passengers. Professional chauffeurs ensure safe ghat road driving and timely pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient mini bus reservations."
  },
  {
    name: "Tempo Traveller on Rent in Pune Rate Per KM",
    description: "Tempo Traveller on rent in Pune rate per km service offers transparent and economical transportation solutions for local and outstation travel requirements. Spacious vehicles ensure smooth highway travel suitable for family trips, group tours, and corporate outings. Professional chauffeurs ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient traveller rental reservations."
  },
  {
    name: "Pune to Mahabaleshwar Tempo Traveller Price",
    description: "Pune to Mahabaleshwar Tempo Traveller price service provides affordable and dependable transportation for tourists, families, and groups planning comfortable hill station travel from Pune. Spacious vehicles ensure smooth highway and ghat road journeys suitable for sightseeing and vacation trips. Professional chauffeurs ensure safe driving and timely pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Mahabaleshwar traveller reservations."
  },
  {
    name: "Pune to Mahabaleshwar Tempo Traveller",
    description: "Pune to Mahabaleshwar Tempo Traveller service offers premium transportation for weekend trips, sightseeing tours, honeymoon vacations, and group travel from Pune. Comfortable seating and spacious interiors ensure pleasant hill station journeys for tourists and families. Professional drivers ensure smooth ghat road travel and reliable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Mahabaleshwar Tempo Traveller reservations."
  }
],

tableData: [
  ["Tempo Traveller from Pune to Mahabaleshwar", "Pune to Mahabaleshwar Tempo Traveller Hire"],
  ["Pune to Panchgani Tempo Traveller", "Tempo Traveller for Rent in Pune"],
  ["Tempo Traveller 17 Seater for Mahabaleshwar Trip", "17 Seater Tempo Traveller for Mahabaleshwar Tour Package"],
  ["Pune Airport to Mahabaleshwar Tempo Traveller on Rent", "Pune to Tapola Tempo Traveller on Rent"],
  ["14 Seater Tempo Traveller for Maharashtra Trip", "Tempo Traveller on Rent Mahabaleshwar Outings"],
  ["Mini Bus on Rent for Mahabaleshwar Trip", "Tempo Traveller on Rent in Pune Rate Per KM"],
  ["Pune to Mahabaleshwar Tempo Traveller Price", "Pune to Mahabaleshwar Tempo Traveller"]
],


  whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Mahabaleshwar Tempo Traveller Service",
        WhyChoosedescription: "Aaradhya Travels provides reliable Pune to Mahabaleshwar Tempo Traveller service with comfortable vehicles, experienced drivers, and smooth travel arrangements for families, tourists, and group tours."
      },
      {
        WhyChooseheading: "Affordable Mahabaleshwar Tempo Traveller Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable Pune to Mahabaleshwar Tempo Traveller rental packages with transparent pricing, flexible trip plans, and no hidden charges for customers."
      },
      {
        WhyChooseheading: "24/7 Tempo Traveller Booking from Pune",
        WhyChoosedescription: "Our Pune to Mahabaleshwar Tempo Traveller booking service is available 24 hours for weekend trips, family vacations, corporate outings, sightseeing tours, and holiday travel."
      },
      {
        WhyChooseheading: "Comfortable & Spacious AC Tempo Travellers",
        WhyChoosedescription: "All Tempo Travellers provided by Aaradhya Travels are fully air-conditioned, spacious, sanitized, and maintained for comfortable hill station travel experiences."
      },
      {
        WhyChooseheading: "One Day & Multi-Day Mahabaleshwar Tours",
        WhyChoosedescription: "Aaradhya Travels offers flexible Pune to Mahabaleshwar travel options including one-day sightseeing tours, weekend getaways, and customized multi-day holiday packages."
      },
      {
        WhyChooseheading: "13, 17 & 20 Seater Tempo Traveller Options",
        WhyChoosedescription: "Customers can choose from 13 seater, 17 seater, and 20 seater Tempo Travellers suitable for family trips, corporate teams, school groups, and tourist travel."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune City",
        WhyChoosedescription: "Aaradhya Travels provides doorstep pickup from homes, hotels, Pune Airport, railway stations, and major Pune locations including Baner, Wakad, Kharadi, Hinjewadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Hill Station Routes",
        WhyChoosedescription: "Our professional drivers are experienced in Mahabaleshwar ghat routes and ensure safe driving, smooth journeys, and comfortable travel throughout the complete trip."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to Mahabaleshwar Tempo Traveller service?", answer: "Pune to Mahabaleshwar Tempo Traveller service provides comfortable group transportation for hill station trips, family tours, and holiday travel." },
    { question: "Is Pune to Mahabaleshwar Tempo Traveller service available 24 hours?", answer: "Yes, Aaradhya Travels provides 24/7 Tempo Traveller booking service from Pune to Mahabaleshwar." },
    { question: "Which Tempo Traveller seating options are available?", answer: "Aaradhya Travels offers 13 seater, 17 seater, and 20 seater Tempo Travellers for different group travel requirements." },
    { question: "Can I book a one-day Mahabaleshwar trip from Pune?", answer: "Yes, customers can book one-day as well as multi-day Mahabaleshwar Tempo Traveller tour packages." },
    { question: "Do you provide customized Mahabaleshwar travel packages?", answer: "Yes, Aaradhya Travels provides customized Mahabaleshwar tour packages according to customer travel requirements." },
    { question: "Are all Tempo Travellers air-conditioned?", answer: "Yes, all Tempo Travellers are fully air-conditioned and maintained for comfortable outstation travel." },
    { question: "Can I book Pune to Mahabaleshwar Tempo Traveller online?", answer: "Yes, customers can easily book Tempo Traveller service online or through phone booking." },
    { question: "Do you provide Tempo Travellers for family and group tours?", answer: "Yes, Aaradhya Travels provides spacious Tempo Travellers suitable for families, tourists, and group travel." },
    { question: "Are Pune to Mahabaleshwar Tempo Traveller charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Mahabaleshwar Tempo Traveller service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and peak tourist seasons." }
  ];

 const testimonials = [
  {
    id: 1,
    name: "Mr. Swapnil Jadhav",
    feedback:
      "The Pune to Mahabaleshwar journey with Aaradhya Travels in a Tempo Traveller was very comfortable and scenic. The vehicle handled the hill route smoothly, and the group enjoyed a relaxed and pleasant travel experience.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Deepali Kulkarni",
    feedback:
      "Aaradhya Travels provided a Tempo Traveller for our Pune to Mahabaleshwar trip, and everything was well managed. The ride was steady on ghat roads, and the entire family had a comfortable and enjoyable journey.",
    rating: 5
  }
];









  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mahabaleshwar Tempo Traveller",
  "image": "https://www.aaradhyatravels99.com/assets/images/pune-to-mahabaleshwar-tempo-traveller.jpg",
  "description": "Book Pune to Mahabaleshwar Tempo Traveller with Aaradhya Travels for family tours, group trips, corporate outings, and weekend vacations. Affordable 14 and 17 seater luxury tempo traveller available for Mahabaleshwar, Panchgani, Tapola, and Maharashtra tours.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "3547"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/pune-to-mahabaleshwar-tempo-traveller"
  }
};


  return (
    <div>
<Helmet>
  <title>
    Pune to Mahabaleshwar Tempo Traveller | 17 Seater Traveller Hire | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire Pune to Mahabaleshwar Tempo Traveller with Aaradhya Travels. Luxury 14 and 17 seater tempo traveller available for Mahabaleshwar, Panchgani, Tapola tours, family trips, corporate outings, airport pickup, and Maharashtra travel packages."
  />

  <meta
    name="keywords"
    content="Tempo traveller from pune to mahabaleshwar, Pune to mahabaleshwar tempo traveller Hire, Pune to Panchgani tempo traveller, Tempo traveller for rent in pune, Tempo traveller 17 Seater for Mahabaleshwar Trip, 17 Seater tempo traveller for mahabaleshwar tour package, Pune Airport to Mahabaleshwar Tempo Traveller on Rent, pune to tapola tempo traveller on rent, 14 seater tempo traveller for maharashtra trip, Tempo traveller on rent mahabaleshwar outings, mini bus on rent for mahabaleshwar trip, Tempo Traveller on rent in Pune rate Per Km, Pune to mahabaleshwar tempo traveller price, pune to mahabaleshwar tempo traveller, mahabaleshwar tempo traveller from pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/2.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomahabaleshwartempotraveller;